import { render, staticRenderFns } from "./PaginateButtonsWithMin.vue?vue&type=template&id=32897500&scoped=true&"
import script from "./PaginateButtonsWithMin.vue?vue&type=script&lang=ts&"
export * from "./PaginateButtonsWithMin.vue?vue&type=script&lang=ts&"
import style0 from "./PaginateButtonsWithMin.vue?vue&type=style&index=0&id=32897500&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32897500",
  null
  
)

export default component.exports